import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { DbStoreState } from '../store/reducers';
import * as fromStore from '../store';
import { UserRoles } from '../user/user-roles';

@Injectable()
export class SetupOnboardingRedirectGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _store: Store<DbStoreState>
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this._store.select(fromStore.getUser).pipe(
      first(),
      map(user => {
        return this._createRedirectUrlTree(route, user);
      })
    );
  }

  private _createRedirectUrlTree(route: ActivatedRouteSnapshot, user: any): UrlTree {
    const queryParams = route.queryParams;
    const transformedParams = this._transformQueryParams(queryParams);

    const role: string = user ? UserRoles.user : UserRoles.guest;
    const isAuthenticated = role !== UserRoles.guest;
    const redirectPath = isAuthenticated ? '/websites' : '/sign-up';

    return this._router.createUrlTree([redirectPath], {
      queryParams: transformedParams,
      fragment: route.fragment
    });
  }

  private _transformQueryParams(queryParams: any): any {
    const transformedParams: any = {
      'generate-website': '1'
    };

    if (queryParams.builder) {
      transformedParams.builderType = queryParams.builder;
    } else if (queryParams.builderType) {
      transformedParams.builderType = queryParams.builderType;
    }

    if (queryParams.prefilledAiData) {
      transformedParams.prefilledAiData = queryParams.prefilledAiData;
    }

    Object.keys(queryParams).forEach(key => {
      if (key !== 'builder' && !transformedParams[key]) {
        transformedParams[key] = queryParams[key];
      }
    });

    return transformedParams;
  }
}
